import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment, { Moment } from "moment";
import { useEffect, useState } from "react";

const DEFAULT_FORMAT = "DD-MM-YYYY";

interface Props {
	label: string;
	onChange: (date: Date | undefined) => void;
	name?: string;
	format?: string;
	/**
	 * Formato "DD-MM-YYYY"
	 */
	value?: Date;
	checkMaggioreEta?: boolean;
}

const AppDatePicker: React.FC<Props> = (props) => {
	const { label, onChange, name, format, value, checkMaggioreEta } = props;

	const [_value, _setValue] = useState<Moment | null>(null);

	const handleChange = (date: Moment | null) => {
		let res = date?.toDate();

		onChange(res);
	};

	useEffect(() => {
		if (value) _setValue(moment(value, "YYYY-MM-DD"));
		else _setValue(null);
	}, [value]);

	const maxDate = checkMaggioreEta ? moment().subtract(18, "years").startOf("day") : undefined;

	return (
		<LocalizationProvider dateAdapter={AdapterMoment}>
			<DatePicker
				format={format || DEFAULT_FORMAT}
				label={label}
				className="app-date-picker"
				value={_value}
				onChange={handleChange}
				maxDate={maxDate}
			/>
		</LocalizationProvider>
	);
};

export default AppDatePicker;
